<div class="w-100 flex flex-row gap-2">
  <div class="container">
    <div #pageContainer class="page-container">
      <div #thumbContainer class="container-i">
        <img class="img1" />
      </div>
      <div #thumbContainer class="container-i">
        <img class="img1" />
      </div>
      <div #thumbContainer class="container-i">
        <img class="img1" />
      </div>
      <div #thumbContainer class="container-i">
        <img class="img1" />
      </div>
    </div>
  </div>
</div>
